import { PodcastWorkflowTemplate } from 'redux/middleware/api/podcast-service';

export function getAspectRatio(template: PodcastWorkflowTemplate) {
  return template?.dimension?.width / template?.dimension?.height;
}
